import { render } from "./RegistrationRequestsPage.vue?vue&type=template&id=3969b9fa&scoped=true"
import script from "./RegistrationRequestsPage.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestsPage.vue?vue&type=script&lang=js"

import "./RegistrationRequestsPage.vue?vue&type=style&index=0&id=3969b9fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3969b9fa"]])

export default __exports__